import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { SERVER_URL } from "src/config";

import PDFViewer from "@components/PDFViewer";
import { LStorage } from "@utils/localStorage";

const linkDef: Record<string, { url: string; label: string }> = {
  terms: {
    url: `${SERVER_URL}/conditions/terms-of-use`,
    label: "Terms of Service",
  },
  privacy: {
    url: `${SERVER_URL}/conditions/privacy-policy`,
    label: "Privacy Policy",
  },
  privacyPractices: {
    url: `${SERVER_URL}/conditions/notice-of-privacy-practices`,
    label: "Notice of Privacy Practices",
  },
  billOfRights: {
    url: `${SERVER_URL}/conditions/bill-of-rights`,
    label: "Bill of Rights",
  },
  endUserAgreement: {
    url: `${SERVER_URL}/conditions/end-user-agreement`,
    label: "End User Agreement",
  },
};

const TermsConsent = ({ marginTop = 1 }: { marginTop?: number }) => {
  const [fileUrl, setFileUrl] = useState<string>("");
    const isMobileApp = LStorage.get("SOURCE_HOST") === "mobile";
  
  const renderLink = (type: string) => {
    const { url, label } = linkDef[type];

    let action: any = { href: url, target: "_blank", rel: "noreferrer" }
    if(isMobileApp) {
      action = { onClick: () => setFileUrl(url) }
    }

    return (
      <Link
        variant="body1"
        sx={{ fontSize: "inherit", cursor: "pointer" }}
        {...action}
      >
        {label}
      </Link>
    );
  };

  return (
    <Box sx={{ marginTop }}>
      <Typography variant="body1" fontSize={14}>
        By clicking "Continue," you confirm that you have read, understood, and
        agree to comply with Ognomy's {renderLink("terms")},{" "}
        {renderLink("privacy")}, {renderLink("privacyPractices")},{" "}
        {renderLink("billOfRights")}, and the {renderLink("endUserAgreement")}
        .{" "}
      </Typography>
      <PDFViewer
        url={fileUrl}
        scale={1.5}
        open={!!fileUrl}
        handleClose={() => setFileUrl("")}
      />
    </Box>
  );
};

export default TermsConsent;
